import {ReducerBuilder} from "@cuatroochenta/co-redux-builders";
import {PagerBackendProps} from "../../../../../components/Pager";
import ReportCancellationLog from "../../../../../commons/model/ReportCancellationLog";
import TaskReportCancellationLogList from "../../../../../commons/ws/reportCancellationLog/TaskReportCancellationLogList";

interface InitialState {
    loading: boolean,
    reportCancelLogs: ReportCancellationLog[],
    error: string,
    pager: PagerBackendProps,
}

const INITIAL_STATE: InitialState = {
    loading: false,
    reportCancelLogs: [],
    error: '',
    pager: {
        current: 1,
        total_pages: 1,
        total_elements: 0,
    },
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)

    .onEvent(TaskReportCancellationLogList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskReportCancellationLogList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskReportCancellationLogList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskReportCancellationLogList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            reportCancelLogs: payload.data,
            pager: payload.pager || oldState.pager
        }
    })

    .build()
